<template>
  <div>
    <form-group-store
      v-for="(group, groupIndex) in groups"
      :key="group.id"
      :path="`${path}/${groupIndex}`"
      :page-read-only="pageReadOnly"
    />
  </div>
</template>

<script>
import FormGroupStore from './FormGroupStore.vue'

/**
 * @class FormPageStore
 *
 * @description This component is a state handler/wrapper for a page of the Form
 */
export default {
  name: 'FormPageStore',
  components: {
    FormGroupStore,
  },
  props: {
    path: {
      type: String,
    },
    pageId: {
      type: String,
    },
    formReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    groups() {
      return this.$get('groupsByPageId')(this.pageId)
    },
    pageReadOnly() {
      return !!(this.formReadOnly || this.page.readOnly)
    },
    page() {
      return this.$get('formPageById')(this.pageId)
    },
  },
}
</script>

<style lang="scss" scoped>
.read-only {
  pointer-events: auto;
}
.nav-link.active {
  background-color: $brandColor !important;
  border-radius: 0.286em;
  color: white !important;
}
.fieldset {
  margin: 0;
  padding: 0;
  .fieldset-legend {
    font-size: inherit;
    margin-bottom: 0;
  }
}
.disabled {
  pointer-events: none;
  .panel-heading {
    pointer-events: all;
  }
  .form-control {
    background-color: rgb(238, 238, 238);
  }
  button.btn-default {
    /*background-color: rgb(214, 119, 119);*/
  }
}
.panel-refresh {
  padding: 0 10px 0 10px;
  color: $brandColor;
  &:before {
    content: none !important;
  }
  &:hover {
    cursor: pointer;
  }
}
.rotate {
  animation: rotating 2s linear;
  animation-iteration-count: infinite;
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.opacity-pulse {
  animation: opacityPulse 2s ease-out;
  animation-iteration-count: infinite;
  opacity: 1;
}
.form-utility {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 3;
}
/*
        .opacity-pulse:hover {
          animation: none;
        }
        */
.tab-pane.card-body.fade {
  visibility: hidden;
  opacity: 0;
  transition:
    visibility 0s 2s,
    opacity 2s linear;
  &.active {
    visibility: visible;
    opacity: 1;
    transition: opacity 2s linear;
  }
  // opacity: 1;
  // transition : all .3s;
  // -webkit-transition : all .3s;
  // -moz-transition : all .3s;
}
@keyframes opacityPulse {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.nav.nav-tabs.card-header-tabs {
  &:focus {
    outline: none;
  }
}
</style>
